import { useQuery } from "@tanstack/react-query";
import { TanstackQueryKey } from "apps/commons/tanstackQueryKey";
import { oneOnboardingApi } from "libs/api";
import type { LocationDropdownItem, LocationDropdownItems, ProfileData } from "libs/codegen/property-onboarding";
import { useState } from "react";
import { type FieldPath, useWatch } from "react-hook-form";
import { useParams } from "router";
import { useDynamicLocation } from "../../commons/hooks/useDynamicLocation";

type ValidPath = FieldPath<ProfileData>;

export const useStateCityList = (fieldPrefix: string) => {
    const { lang } = useParams("/:lang/list-my-property/onboard/:propertyId/location");

    const countryDropdown = useWatch<ProfileData>({
        name: `${fieldPrefix}.country` as ValidPath,
    }) as LocationDropdownItem;
    const stateDropdown = useWatch<ProfileData>({
        name: `${fieldPrefix}.state` as ValidPath,
    }) as LocationDropdownItem;

    const [data, setData] = useState<LocationDropdownItems>({
        states: [],
        cities: [],
    });

    const { pathname } = useDynamicLocation();

    useQuery({
        queryKey: [TanstackQueryKey.GetLocationDropdown, lang, countryDropdown, stateDropdown, pathname],
        queryFn: () => {
            if (countryDropdown || stateDropdown)
                return oneOnboardingApi
                    .getLocationDropdown(lang, countryDropdown?.id ?? 0, stateDropdown?.id ?? 0, pathname)
                    .then((res) => res.data);

            return {
                cities: [],
                states: [],
            } satisfies LocationDropdownItems;
        },
        onSuccess: (data) => {
            setData({
                states: data.states ?? [],
                cities: data.cities ?? [],
            });
        },
    });

    return data;
};
